/* eslint-disable
    func-names,
    valid-typeof,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = [];

const factory = function () {
  class Validate {
    required() {
      return attr => attr || attr === 0;
    }
    type(type) {
      return attr => typeof attr === type;
    }
    pattern(test) {
      return function (attr) {
        const regExp = new RegExp(test);
        return regExp.test(attr);
      };
    }
  }

  return new Validate();
};

factory.$inject = deps;

module.exports = factory;
